import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { RolesSharedService } from './roles-shared.service';

@Injectable()
export class BookMarkMarketDataResolverService implements Resolve<Observable<any>> {

constructor(private rolesSharedService: RolesSharedService) { }
marketDataFilter() {
  const filter: any = {};
  filter.filter = JSON.stringify({
    include: [
      "subCategory",
      "graphType",
      {
        likes: "user"
      },
      {
        comments: "user"
      },
      {
        bookmark: "user"
      },
      {
        ratings: "user"
      }
    ]

  });

  return filter;
}
resolve(route: ActivatedRouteSnapshot) {
  const marketDataId = route.params.marketDataId;
  const researchDocumentId = route.params.researchId;
  return this.rolesSharedService.getMarketData(  marketDataId, this.marketDataFilter(), researchDocumentId);
 }

}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/services/book-mark-market-data-resolver.service.ts